import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';

import { DatePipe } from '@angular/common';

import { CoreModule } from './core/core.module';
import { ContentComponent } from './pages/content/content.component';
import { SharedModule } from './shared/shared.module';
// import { ChatTextareaComponent } from './shared/components/chat-textarea/chat-textarea.component';
// import { PromptListComponent } from './shared/components/prompt-list/prompt-list.component';
import { OptionStyleComponent } from './shared/components/option-style/option-style.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import { OktaService } from './services/okta.service';
import { TranslateLayoutComponent } from './layouts/translate-layout/translate-layout.component';
@NgModule({
  declarations: [
    AppComponent,
    MainLayoutComponent,
    ContentComponent,
    // ChatTextareaComponent,
    // PromptListComponent,
    OptionStyleComponent,
    TranslateLayoutComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CoreModule,
    SharedModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.deployment !== 'DEV',
       registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    OktaService,
    DatePipe
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
